import { isClanBattleType } from "helpers/ladder";
import isEmpty from "lodash/isEmpty";
import { createSelector } from "reselect";
import settings from "../../settings";

const reduceByField = (items: any, key: any) => items.map((item: any) => item[key]).reduce((prev: any, curr: any) => prev + curr);

export const defaultMembers = Object.freeze([]);
export const defaultDisabledIds = Object.freeze([]);
export const defaultSort = Object.freeze({
  field: 'name',
  isAsc: true
});

export const currentAccountSelector = state => state.currentAccount;
export const clanSelector = (state, clanId) => state.clans.items[clanId];
export const clanStatisticsSelector = (state, clanId) => state.members.statistics[clanId];
export const clanLadderSelector = (state, clanId) => state.clans.wowsLadder[clanId];
export const membersSelector = (state, clanId) => {
  const membersState = state.members.clans[clanId];
  return membersState ? membersState.members : defaultMembers;
};
export const clanCurrentBattleTypeSelector = (state, clanId) => {
  return state.members.battleTypes[clanId] || settings.defaultBattleType;
};


export const statisticsSelector = createSelector(clanSelector, clanStatisticsSelector, clanLadderSelector, membersSelector, clanCurrentBattleTypeSelector, (clan, currentClanStatistics, currentLadderStatistics, members, currentBattleType) => {
  const clanStatistics = currentClanStatistics ? currentClanStatistics.statistics : null;
  const isHiddenStatistics = currentClanStatistics ? currentClanStatistics.isHiddenStatistics : false;

  const isClanBattleWithStatistics = isClanBattleType(currentBattleType) && !isEmpty(clanStatistics);
  const ladderMaxPosition = isClanBattleWithStatistics ? clanStatistics.max_position : null;

  const statistics = {
    currentBattleType,
    totalMembers: clan ? clan.members_count : null,
    maxMembersCount: clan ? clan.maxMembersCount : null,
    averageBattlesCounts: null,
    averageExperiencePerBattle: null,
    averageDamagePerBattle: null,
    averageWinsPercentage: null,
    winsCount: null,

    leadingTeamNumber: isClanBattleWithStatistics ? clanStatistics.leading_team_number : null,
    ratings: isClanBattleWithStatistics ? clanStatistics.ratings : null,
    ladderBattlesCount: isClanBattleWithStatistics ? clanStatistics.battles_count : null,
    ladderWinsPercent: (isClanBattleWithStatistics && currentLadderStatistics) ? clanStatistics.wins_count / clanStatistics.battles_count * 100 : null,
    ladderMaxLeague: ladderMaxPosition ? ladderMaxPosition.league : null,
    ladderMaxDivision: ladderMaxPosition ? ladderMaxPosition.division : null,
    ladderMaxDivisionRating: ladderMaxPosition ? ladderMaxPosition.division_rating : null,
    ladderWinStreak: isClanBattleWithStatistics ? clanStatistics.longest_winning_streak : null,

    ladderWinsCount: isClanBattleWithStatistics ? clanStatistics.wins_count : null
  };

  if (!isHiddenStatistics) {
    if (clanStatistics) {
      statistics.averageBattlesCounts = clanStatistics.battles_count;
      statistics.averageExperiencePerBattle = clanStatistics.exp_per_battle;
      statistics.averageDamagePerBattle = clanStatistics.damage_per_battle;
      statistics.averageWinsPercentage = clanStatistics.wins_percentage;
    } else if (members.length > 0) {
      const battlesCount = reduceByField(members, 'battlesCount');
      if (battlesCount > 0) {
        const wins = members.reduce((prev, item) => prev + item['battlesCount'] * item['winsPercentage'] / 100, 0);
        const totalDamage = members.reduce((prev, item) => prev + item['damagePerBattle'] * item['battlesCount'], 0);
        const totalExperience = members.reduce((prev, item) => prev + item['expPerBattle'] * item['battlesCount'], 0);

        statistics.averageBattlesCounts = battlesCount / members.length;
        statistics.averageWinsPercentage = wins / battlesCount * 100;
        statistics.averageExperiencePerBattle = totalExperience / battlesCount;
        statistics.averageDamagePerBattle = totalDamage / battlesCount;
      }
    }
  }

  return statistics;
});